import { service } from '@ember/service'
import Route from '@ember/routing/route'
import RSVP from 'rsvp'
import type UiScopeRoute from 'district-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'district-ui-client/services/student-events'
import { toStatsScope, type StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'

export default class MsTimeOnTaskRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope: scope, period, scopedData } = this.modelFor('reporting.ui-scope') as ModelFor<UiScopeRoute>

    const statsScope = toStatsScope(scope)
    const product: LegacyProductMs = 'maths'
    const stats = await this.makeStatsRequest(product, statsScope, period)

    return {
      product,
      scope,
      period,
      scopedData,
      ...stats,
    }
  }

  makeStatsRequest = (product: LegacyProductMs, scope: StatsScope, period: NormalizedInterval) => {
    const { studentEvents } = this

    return RSVP.hash({
      timeOnTaskHistory:
        scope.scope === 'district'
          ? studentEvents.timeOnTaskHistoryDistrict(product, scope, period)
          : studentEvents.timeOnTaskHistorySchool(product, scope, period),
      timeOnTaskUsage: studentEvents.timeOnTaskUsage(product, scope, period),
    })
  }
}
